import React, { Component } from 'react';
import { get } from 'lodash';

/* eslint-disable react/no-did-mount-set-state */

export default class Notice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
      message1: get(props, 'homepageTopPromo.text_1', ''),
      message2: get(props, 'homepageTopPromo.text_2', ''),
      link: get(props, 'homepageTopPromo.link', '')
    };

    this.closeNotice = this.closeNotice.bind(this);
  }

  componentDidMount() {
    // this.setState({ show: document.cookie.indexOf('fc_notice_closed') === -1 });

    setInterval(() => {
      if (this.state.show) {
        if (
          document.querySelector('.slide.slide1').classList.contains('show')
        ) {
          document
            .querySelector('.slide.slide1')
            .classList.replace('show', 'hide');
          document
            .querySelector('.slide.slide2')
            .classList.replace('hide', 'show');
        } else if (
          document.querySelector('.slide.slide1').classList.contains('hide')
        ) {
          document
            .querySelector('.slide.slide1')
            .classList.replace('hide', 'show');
          document
            .querySelector('.slide.slide2')
            .classList.replace('show', 'hide');
        }
      }
    }, 3000);
  }

  closeNotice() {
    document.cookie = 'fc_notice_closed';
    this.setState({ show: false });
  }

  render() {
    if (!this.state.show) {
      return false;
    }

    return (
      <section className="notice">
        <div className="inner">
          <div className="slide slide1 show">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={this.state.link}
              dangerouslySetInnerHTML={{ __html: this.state.message1 }}
            />
          </div>

          <div className="slide slide2 hide">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={this.state.link}
              dangerouslySetInnerHTML={{ __html: this.state.message2 }}
            />
          </div>

          <div
            className="close"
            onClick={() => {
              this.closeNotice();
            }}
          >
            <img
              src="https://images.fastcompany.net/image/upload/v1599849526/fcweb/ex_ndgqh7.svg"
              alt="X"
            />
          </div>
        </div>
      </section>
    );
  }
}
